import React, { useState } from 'react';

import { Alert } from 'antd';
import Axios from 'axios';
import { Formik, Field } from 'formik';

import { forceReloadInvoice } from '@hooks/API/UseInvoices';

import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import { NWAccountCodeSelector } from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';

const ChangeAccountDrawer = ({ onClose, invoiceID, records }) => {
    const [touchForm, setTouchForm] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const initialValues = {
        AccountCode: records[0].AccountCode ? records[0].AccountCode : null,
    };

    const saveAccountCode = async (values, setSubmitting) => {
        setSubmitting(true);
        setErrorMessage(null);
        try {
            const promises = records.map((record) => {
                if (record.RowIds.length === 1) {
                    return Axios.put('/invoices/rows/setaccountcode', {
                        InvoiceID: invoiceID,
                        RowID: record.index,
                        AccountCode: values.AccountCode,
                    });
                } else {
                    return Axios.put('/invoices/rows/setgroupaccountcode', {
                        InvoiceID: invoiceID,
                        GroupGuid: record.Guid,
                        AccountCode: values.AccountCode,
                    });
                }
            });
            await Promise.all(promises);
            forceReloadInvoice(invoiceID);
            onClose();
        } catch (e) {
            // With several rows some calls may have succeeded: reload to show what was saved
            forceReloadInvoice(invoiceID);
            setErrorMessage(`Error saving account code: ${e?.message || 'unknown error'}`);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <NwDrawer touchForm={touchForm} onTouchForm={setTouchForm} onClose={onClose} title="Change Account Code">
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    saveAccountCode(values, setSubmitting);
                }}
            >
                {({ isSubmitting, values, handleSubmit }) => (
                    <NwForm values={values} onTouchForm={setTouchForm} onFinish={handleSubmit}>
                        <Field
                            component={NWAccountCodeSelector}
                            label="Account #"
                            name="AccountCode"
                            value={values.AccountCode}
                        />
                        {errorMessage && <Alert style={{ margin: '1rem 0' }} message={errorMessage} type="error" />}
                        <NwFormButtonsBar
                            left={
                                <NwCancelButton
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        setTouchForm(false);
                                        onClose();
                                    }}
                                />
                            }
                            right={<NwSaveButton htmlType="submit" disabled={isSubmitting} loading={isSubmitting} />}
                        />
                    </NwForm>
                )}
            </Formik>
        </NwDrawer>
    );
};

export default ChangeAccountDrawer;
